import React, { useState, useEffect } from 'react';
import PropertyFilter from './PropertyFilter';
import PropertyPagination from './PropertyPagination';
import '../../assets/css/PropertyListingContainer.css'; 
import PropertyCard from './PropertyCard';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error('React Error Boundary caught an error:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            return <div>Something went wrong. Please check the console for details.</div>;
        }

        return this.props.children;
    }
}

const PropertyListingContainer = () => {
    
    // Move state declarations to the top
    const [properties, setProperties] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [filters, setFilters] = useState({
      price_min: '',
      price_max: '',
      bedrooms: '',
      bathrooms: '',
      property_type: '',
      property_status: '',
      property_location: ''
    });
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);

    // Calculate these values after state declarations
    const itemsPerPage = 10;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentProperties = properties.slice(indexOfFirstItem, indexOfLastItem);

    const fetchProperties = async () => {
      setLoading(true);
      try {
        const response = await fetch('/wp-json/wp/v2/property?_embed&per_page=100');
        if (!response.ok) {
          throw new Error('Failed to fetch properties');
        }
        
        const data = await response.json();
        
        setProperties(data);
        setTotalPages(Math.ceil(data.length / 10));
        setLoading(false);
      } catch (err) {
        console.error('Error fetching properties:', err);
        setError(err.message);
        setLoading(false);
      }
    };
    
    useEffect(() => {
      fetchProperties();
    }, []);

  
    const handleFilterChange = (newFilters) => {
      setFilters(newFilters);
      setCurrentPage(1); // Reset to first page when filters change
    };
    
    const handlePageChange = (page) => {
      setCurrentPage(page);
      window.scrollTo(0, 0);
    };
    
    return (
      <ErrorBoundary>
        <div className="property-app">
          <PropertyFilter 
            filters={filters} 
            onFilterChange={handleFilterChange} 
          />
          
          {loading ? (
            <div className="loading">Loading properties...</div>
          ) : error ? (
            <div className="error">Error: {error}</div>
          ) : properties.length === 0 ? (
            <div className="no-results">No properties found.</div>
          ) : (
            <>
              <div className="properties-grid">
                {currentProperties.map(property => (
                  <PropertyCard
                    key={property.id}
                    property={property}
                  />
                ))}
              </div>
              {totalPages > 1 && (
                <PropertyPagination 
                  currentPage={currentPage} 
                  totalPages={totalPages} 
                  onPageChange={handlePageChange} 
                />
              )}
            </>
          )}
        </div>
      </ErrorBoundary>
    );
  };

export default PropertyListingContainer;